import UserDispatcherListRequest, {
  UserDispatcherListRequestStatusCriteria,
  UserDispatcherListRequestOrder,
} from "../../../../api/raily/user/dispatcher/list/user-dispatcher-list.request";
import UserOrder from "../../../../types/user-order";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import UserDispatcherListParams from "./user-dispatcher-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserDispatcherListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserDispatcherListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserDispatcherListRequestStatusCriteria.DELETED;
    default:
      return UserDispatcherListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserOrder | undefined,
): UserDispatcherListRequestOrder | undefined => {
  switch (status) {
    case UserOrder.FIRST_NAME_ASC:
      return UserDispatcherListRequestOrder.FIRST_NAME_ASC;
    case UserOrder.FIRST_NAME_DESC:
      return UserDispatcherListRequestOrder.FIRST_NAME_DESC;
    case UserOrder.LAST_NAME_ASC:
      return UserDispatcherListRequestOrder.LAST_NAME_ASC;
    case UserOrder.LAST_NAME_DESC:
      return UserDispatcherListRequestOrder.LAST_NAME_DESC;
    case UserOrder.USERNAME_ASC:
      return UserDispatcherListRequestOrder.USERNAME_ASC;
    case UserOrder.USERNAME_DESC:
      return UserDispatcherListRequestOrder.USERNAME_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: UserDispatcherListParams,
): UserDispatcherListRequest => {
  return {
    cargoCompany: params.cargoCompany,
    cargoCompanyId: params.cargoCompanyId,
    dispatch: params.dispatch,
    dispatchId: params.dispatchId,
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    offset:
      params.page && params.pageSize
        ? paginationService.calculateOffset(params.page, params.pageSize)
        : undefined,
    order: createOrder(params.order),
    statusCriteria: createStatusCriteria(params.status),
    username: params.username,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    limit: params.pageSize,
  };
};

const userDispatcherListParamsFactory = { create };

export default userDispatcherListParamsFactory;
